import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

export const useEnvironmentVariables = () => {
  const page = usePage()

  const streamApiKey = computed(() => page.props.shared.envs.streamApiKey)
  const streamBaseUrl = computed(() => page.props.shared.envs.streamBaseUrl)
  const streamAppId = computed(() => page.props.shared.envs.streamAppId)
  const teamMaxSeats = computed(() => page.props.shared.envs.teamMaxSeats)
  const recaptchaSiteKey = computed(
    () => page.props.shared.envs.recaptchaSiteKey,
  )
  const minimumReferralPayoutAmount = computed(
    () => page.props.shared.envs.minimumReferralPayoutAmount,
  )
  const giphyApiKey = computed(() => page.props.shared.envs.giphyApiKey)

  return {
    streamApiKey,
    streamBaseUrl,
    streamAppId,
    teamMaxSeats,
    recaptchaSiteKey,
    minimumReferralPayoutAmount,
    giphyApiKey,
  }
}
